import React, { useState } from 'react'
import { Box, Typography } from '@mui/material'

import { elementContainer } from '../../styles/classes/MobilePreviewClasses'
import { faQuestionCircle } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import HelpfulHintPopUp from './HelpfulHintPopUp'

const ElementContainer = ({ title, helpfulHint, isMandatory, children, applyShadow }) => {
  const [open, setOpen] = useState(false)
  const { classes } = elementContainer()

  const openCloseModalHandler = () => {
    setOpen(prev => !prev)
  }

  return (
    <Box className={applyShadow ? classes.shadow : undefined}>
      <Box className={classes.container}>
        <Typography className={classes.title}>
          {isMandatory && <span className={classes.required}>*</span>}
          {title}
        </Typography>
        {helpfulHint?.length > 0 && (
          <FontAwesomeIcon
            className={classes.icon}
            icon={faQuestionCircle}
            onClick={openCloseModalHandler}
          />
        )}
      </Box>
      {children}
      <HelpfulHintPopUp
        open={open}
        onClose={openCloseModalHandler}
        text={helpfulHint}
      />
    </Box>
  )
}

export default ElementContainer
